import React from 'react'

const PublicNewRoute = ({children}) => {
  return  children
}

export default PublicNewRoute